import { render, staticRenderFns } from "./agentBoardList.vue?vue&type=template&id=c795b6f2&scoped=true"
import script from "./agentBoardList.vue?vue&type=script&lang=js"
export * from "./agentBoardList.vue?vue&type=script&lang=js"
import style0 from "./agentBoardList.vue?vue&type=style&index=0&id=c795b6f2&prod&scoped=true&lang=css"
import style1 from "./agentBoardList.vue?vue&type=style&index=1&id=c795b6f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c795b6f2",
  null
  
)

export default component.exports